module.exports = __webpack_public_path__ + "img/thumbnail_GreaterFlamingo_j_normal.080300e7.png";